import React from 'react';

interface DescriptionContainerElementProps {
  description: string;

  collapse?: {
    collapseAction: (state: boolean) => void;
    collapseText: string;
    collapseTitle?: string;
    expandText: string;
  };
}

interface DescriptionContainerElementState {
  collapsed: boolean;
}

export default class DescriptionContainerElement extends React.Component<
  DescriptionContainerElementProps,
  DescriptionContainerElementState
> {
  /**
   *
   */
  constructor(props: DescriptionContainerElementProps) {
    super(props);
    this.state = { collapsed: false };
  }
  toggleState() {
    let newState: boolean = !this.state.collapsed;
    this.setState({ collapsed: newState });
    return newState;
  }
  render() {
    return (
      <div className="DescriptionContainerElement">
        <h3 className="border">{this.props.description}</h3>
        <div className="DescriptionContainerElementChild">
          {this.props.children}
        </div>
        {this.props.collapse != null ? (
          <div className="button-artikel">
            <a
              className="mehr-erfahren"
              onClick={() => {
                this.props.collapse?.collapseAction(this.toggleState());
              }}
              title={this.props.collapse?.collapseTitle}
            >
              {this.state.collapsed
                ? this.props.collapse?.expandText
                : this.props.collapse?.collapseText}
            </a>
          </div>
        ) : null}
      </div>
    );
  }
}
